module.exports = __webpack_public_path__ + "static/img/bg-en.73075890.webp";